<template>
    
    <div>
        
        <div class="text-center pa-6" v-if="audittrails_loader">
            
            <v-progress-circular
            indeterminate
            color="blue"
            ></v-progress-circular>
            
        </div>

         <v-row>

            <v-col>

                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="logDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="logDate"
                        :label="$t('Filter by date')"
                        readonly
                        v-on="on"
                        outlined
                        clearable
                        reactive
                        @change="setDate()"
                        @click:clear="setDate()"
                    ></v-text-field>
                    </template>
                    <v-date-picker 
                        v-model="logDate" 
                        no-title 
                        close-on-select
                        @input="$refs.menu.save(logDate)"
                        @change="setDate()"
                    ></v-date-picker>
                </v-menu>

            </v-col>

            <v-col>

                <v-select
                v-model="logTypesSelected"
                :items="logTypes"
                :label="$t('Select log type')"
                item-text="text"
                item-value="value"
                outlined
                return-object
                clearable
                close-on-select
                @change="setLogType()"
                
                ></v-select>

            </v-col>

            <!-- <v-col>

                <v-select
                v-model="usersSelected"
                :items="users"
                :label="$t('Select a user')"
                outlined
                return-object
                clearable
                @click="setUser()"
                ></v-select>

            </v-col> -->

        </v-row>

        <v-card outlined tile v-for="audittrail in audittrails" :key="audittrail.id"  @click="showLogPopup(audittrail);">

            <v-row align='center' class="pl-4">
                <v-col>{{audittrail.log_date}}</v-col>
                <v-col>{{ get_userById(audittrail.user_id) }}</v-col>
                <v-col>{{audittrail.text}}</v-col>
                <v-col cols="1">
                    <v-btn icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                </v-col>

            </v-row>

        </v-card>

       
        <div v-if="error">
            
            <v-alert type="error">
                {{error}}
            </v-alert>

            <div>

                <v-btn @click="signOut()">
                    {{ $t('Logout') }}
                </v-btn>

            </div>

        </div>

        <!-- {{logDate}}
        {{logTypesSelected.value}}
        {{usersSelected}} -->

        <v-dialog
        v-model="logPopup"
        width="500"
        >
        <v-card outlined>
            
            <v-card-title>

                <h3>{{ $t('Log') }} # {{selectedTag.id}}</h3>

                <v-spacer></v-spacer>

                <v-btn icon @click="hideLogPopup()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pt-6">
                <p><b>{{ selectedTag.text }}</b></p>
                <p>{{ $t('Date') }}: {{ selectedTag.log_date }}</p>
                <p>{{ $t('User') }}: {{ get_userById(selectedTag.user_id) }}</p>
                <p>{{ $t('Type') }}: {{ selectedTag.type }}</p>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-title>

                <h5>{{ $t('New') }}</h5>

            </v-card-title>


            <v-card-text class="pt-4">
                
                <vue-code-highlight>
                
                    {{ selectedTag.data }}
                    <!-- {
                        "user_id": 43597
                    } -->

                </vue-code-highlight>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-title>

                <h5>{{ $t('Old') }}</h5>

            </v-card-title>


            <v-card-text class="pt-4">
                <vue-code-highlight>
                
                    {{ selectedTag.data_previous }}
                    <!-- {
                        "user_id": 43597
                    } -->

                </vue-code-highlight>
               
            </v-card-text>

        </v-card>

    </v-dialog>

    </div>

</template>

<script>

import { mapGetters, mapActions } from "vuex";
import auditTrailsApi from "@/api/audittrails/AuditTrails" ;
import firebase from "firebase";

export default {

    name: "AuditTrails",
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: 'user/current',
        })
    },
    data () {
        return {
            audittrails_loader: true,
            error: null,
            audittrails: [],
            menu: false,
            modal: false,
            menu2: false,
            logDate: null,
            usersSelected: { text: '', value: '' },
            users: [],
            logTypesSelected: { text: '', value: '' },
            logTypes: [
                { text: 'Tag', value: 'tag' },
                { text: 'Device', value: 'device' },
                { text: 'Reporter', value: 'reporter' },
                { text: 'Function', value: 'function' },
                { text: 'Rights', value: 'rights' },
                { text: 'System', value: 'system' }
            ],
            logPopup: false,
            selectedTag: {
            },

        }
    },
    created() {

        this.logPopupTag = this.audittrails[0];

        this.users = [
            { text: this.user.displayName, value: this.user.id }
        ]

        this.usersSelected.text = this.user.displayName;
        this.usersSelected.value = this.user.id;

        this.getAuditTrails();

    },
    methods: {

        ...mapActions({
            //setAuditTrail: 'audiTrails/setAuditTrail'
        }),
        
        // setUser(){
        //     console.log('setUser');
        //     console.log(this.usersSelected);
        // },


        setLogType(){
             console.log('SetLogType' + this.logTypesSelected);

             if(!this.logTypesSelected){
                 this.logTypesSelected = { text: '', value: '' }
             }
             this.getAuditTrails();
        },

        setDate(){

             this.getAuditTrails();
             
        },

        get_userById(user_id){

            if(user_id == this.user.id){
                return this.user.displayName ;
            }else{
                return '' ;
            }
            

        },
        signOut() {

            firebase
            .auth()
            .signOut()
            .then(() => {

            // this.$router.push({
            //   name: "Login"
            // });

            });
        },

        getAuditTrails() {

            let _this = this ; 
            let api = new auditTrailsApi() ;

            if(this.usersSelected.value){
                console.log("user selected");
                api.set_user_id(this.usersSelected.value);
            }

            if(this.logTypesSelected.value){
                console.log("types selected");
                api.set_type(this.logTypesSelected.value);
            }

            if(this.logDate){
                console.log("logdate selected");
                api.set_date(this.logDate);
            }


            api.get().then(function(data) {

                _this.audittrails = data ; 

                // success
                console.log(data);

                if(typeof data === 'string'){
                    _this.error = _this.$t('No audit trails found') ; 
                }

                _this.audittrails_loader = false ;

            })
            .catch(errorMessage => {

                if(errorMessage.response){
                    _this.error = errorMessage.response.data.error.message+" ("+errorMessage.response.data.error.code+")" ; 
                }else{
                    _this.error = errorMessage ; 
                }

                _this.audittrails_loader = false ;
                
            });

        },
        
        showLogPopup(audittrail) {
            this.selectedTag = audittrail;
            this.logPopup = true ;
        },
        hideLogPopup() {
            this.logPopup = false ;
        },

       
    }

};

</script>